import { CardsList } from "./CardsList";
import { Destination } from "./RankifierCard/Destination";
import { GameHandler, GameHandlerProps } from "../../types";
import { Heading } from "./Heading";
import { Playground } from "./Playground";
import { RANKIFIER_ROOT_ID } from "../../constants";
import { RankifierContextProvider } from "../../contexts/rankifier";
import BrownCard from "../../assets/images/cards/brown.png";

import styles from "./RankifierGame.module.scss";

export const RankifierGame: GameHandler = ({ game, finishGame }: GameHandlerProps) => {
  return (
    <RankifierContextProvider key={game.id} game={game} onGameFinished={finishGame}>
      <div className={styles.rankifierGame} id={RANKIFIER_ROOT_ID}>
        <CardsList cardReverseImage={BrownCard} />
        <Heading />
        <Playground />

        <div className={styles.rankifierBottom}>
          <Destination kind="deck" />
          <Destination kind="selected" />
        </div>
      </div>
    </RankifierContextProvider>
  );
};
